import { useContext } from "react";
import { TicketContext } from "../contexts/Tickets/TicketContext";

export function useTicket() {
  const context = useContext(TicketContext);

  return context;
}
